import { HeatingMode } from 'z3k-config';
import { calcTemp2Color } from '../type';
import { getContrastRatio } from '@mui/material';
import { prettyFloat } from 'utils';
import { partial } from 'webui/utils/functions';
import { getModeColor } from 'console/device-settings/z3k/components/utils/ColorPicker4bit';
export function getFromDefaultTemp(heating_modes, temp_or_mode, selected_hc) {
    const { mode, temp } = temp_or_mode;
    if (temp != null && HeatingMode.special_modes.includes(temp)) {
        const name = HeatingMode.getSpecialModeName(temp);
        if (temp === HeatingMode.OFF_MODE) {
            return {
                temp_str: name,
                color: '#e00000',
            };
        }
        if (temp === HeatingMode.REQUEST_MODE) {
            return {
                temp_str: name,
                color: '#7bd915',
            };
        }
        if (temp === HeatingMode.ALWAYS_ON_MODE) {
            return {
                temp_str: name,
                color: '#15b1d9',
            };
        }
        if (temp === HeatingMode.RESERVE_MODE) {
            return {
                temp_str: name,
                color: '#d98715',
            };
        }
    }
    //Если это режим
    if (mode != null) {
        //Пробуем его найти
        const index = heating_modes.findIndex((hm) => hm.id === mode.id);
        const found_mode = heating_modes[index];
        if (!found_mode) {
            return { temp_str: 'Неизвестный режим', color: '#cccccc' };
        }
        // const temp_from_heating_zones = found_mode.heating_zones
        //     .filter((hz) => hz.heating_circuit === selected_hc.id)
        //     .map((hz) => getTempOrMode(hz.temperature_setting, heating_modes));
        // const temp_or_mode = temp_from_heating_zones[0];
        return {
            temp_str: found_mode.name,
            color: getModeColor(found_mode, index) ?? '#cccccc',
        };
    }
    return {
        temp_str: temp === -273 ? '' : prettyFloat(temp ?? 20, 1) + '°',
        color: calcTemp2Color(temp ?? 20),
    };
}
const compareToBlack = partial(getContrastRatio, '#222222');
const compareToWhite = partial(getContrastRatio, '#ffffff');
export function getPrimaryContrastText(background_color) {
    return compareToBlack(background_color) > compareToWhite(background_color)
        ? '#222222'
        : '#ffffff';
}
